import { useServices } from "./useServices.js";
const useFileType = ()=>useServices().fileType;
export { useFileType };
